<footer class="page-footer">
  <div class="footer-content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-sm-6">
          <!-- <p class="mb-0 text-muted"></p> -->
         <p class="mb-0  pt-2 ps-4"> <span>Version: 5.0.6</span><span>, Build: 12-Oct-2026-11:45PM</span> Copyright © <span class="year-update">{{ getCurrentYear() }}</span>
          Etrapp. All rights reserved.</p>
        </div>
        <!-- <div class="col-sm-6 d-none d-sm-block">
          <ul class="breadcrumb pt-0 pr-0 float-right">
            <li class="breadcrumb-item mb-0">
              <a href="javascript:;" class="btn-link">Review</a>
            </li>
            <li class="breadcrumb-item mb-0">
              <a href="javascript:;" class="btn-link">Purchase</a>
            </li>
            <li class="breadcrumb-item mb-0">
              <a href="javascript:;" class="btn-link">Docs</a>
            </li>
          </ul>
        </div> -->
        <div class="col-sm-6 d-none d-sm-block" *ngIf="showToggle">
          <div class="float-right">
            <div class="custom-control custom-switch">
              <input type="checkbox"
                    class="custom-control-input"
                    id="autorefresh"
                    [(ngModel)]="autoRefreshEnabled"
                    (change)="toggleAutoRefresh()">
              <label class="custom-control-label" for="autorefresh">
                Auto Refresh
              </label>
            </div>
          </div>
        </div>


            
   
      </div>
    </div>
  </div>
</footer>
